import { render, staticRenderFns } from "./SkyQuery.vue?vue&type=template&id=37af64f6&"
import script from "./SkyQuery.vue?vue&type=script&lang=js&"
export * from "./SkyQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37af64f6')) {
      api.createRecord('37af64f6', component.options)
    } else {
      api.reload('37af64f6', component.options)
    }
    module.hot.accept("./SkyQuery.vue?vue&type=template&id=37af64f6&", function () {
      api.rerender('37af64f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/workspace/SkyQuery.vue"
export default component.exports